/**
 * ResetPasswordSuccessPage — autenticazione Phase 6 (IMPL-P6-002).
 *
 * UC-008 terminal page after a successful password reset. Shows a positive
 * confirmation and auto-redirects to `/accedi` after 3 seconds so the user
 * doesn't need to click anything (with an explicit CTA as a fallback for
 * users who want to skip the wait).
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { AuthStatusPage } from '../components/AuthStatusPage';

export function ResetPasswordSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/accedi', { replace: true });
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <AuthStatusPage
      icon={CheckCircle2}
      tone="success"
      title="Password aggiornata"
      description="La tua password è stata aggiornata con successo. Tra pochi istanti verrai reindirizzato alla pagina di accesso."
      primaryAction={{ label: 'Accedi ora', to: '/accedi' }}
    />
  );
}
